export const BANKS = [
  {
    id: 46,
    name: 'Akbank',
  },
  {
    id: 203,
    name: 'Albaraka',
  },
  {
    id: 135,
    name: 'Anadolu Bank',
  },
  {
    id: 125,
    name: 'Burgan Bank',
  },
  {
    id: 134,
    name: 'Deniz Bank',
  },
  {
    id: 111,
    name: 'QNB Finansbank',
  },
  {
    id: 12,
    name: 'Halk Bank',
  },
  {
    id: 99,
    name: 'ING Bank',
  },
  {
    id: 205,
    name: 'Kuveyt Türk',
  },
  {
    id: 59,
    name: 'Şekerbank',
  },
  {
    id: 206,
    name: 'Türkiye Finans',
  },
  {
    id: 67,
    name: 'Yapı Kredi',
  },
  {
    id: 167,
    name: 'Yapı Kredi',
  },
  {
    id: 143,
    name: 'Aktif Bank',
  },
  {
    id: 124,
    name: 'Alternatif Bank',
  },
  {
    id: 92,
    name: 'Citi Bank',
  },
  {
    id: 103,
    name: 'Fibabanka',
  },
  {
    id: 62,
    name: 'Garanti',
  },
  {
    id: 123,
    name: 'HSBC',
  },
  {
    id: 64,
    name: 'İş Bankası',
  },
  {
    id: 146,
    name: 'Odea Bank',
  },
  {
    id: 32,
    name: 'Teb',
  },
  {
    id: 15,
    name: 'VakıfBank',
  },
  {
    id: 10,
    name: 'Ziraat Bankası',
  },
  {
    id: 209,
    name: 'Ziraat Katılım',
  },
];
